import Cookies from 'js-cookie';
import countdown from '../../vendor/countdown';

const padNumber = (value, difference) => {
    if (difference <= 0) {
        return '00';
    }

    return value.toString().padStart(2, '0');
};

export default () => ({
    countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    },
    announcementId: '',
    formSubmitted: false,
    isSubmitting: false,
    visible: false,

    init() {
        this.announcementId = 'gifted-' + this.$root.dataset.announcementId;
        const announcementDelay = parseInt(this.$root.dataset.announcementDelay) || 0;
        const hasCountdown = this.$root.dataset.announcementCountdown === 'true';
        const endTimestamp = this.$root.dataset.announcementEnd;

        setTimeout(() => {
            if (!Cookies.get(this.announcementId)) {
                this.visible = true;
                document.body.classList.add(this.announcementId + '-announcement-is-visible');
                window.dispatchEvent(new CustomEvent('gifted.announcementOpened'));
            }
        }, announcementDelay);

        if (hasCountdown && endTimestamp) {
            const endDate = endTimestamp * 1000;

            const updateDifference = () => {
                const difference = countdown(
                    Date.now(),
                    endDate,
                    countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
                );

                this.countdown.days = padNumber(difference.days, difference.value);
                this.countdown.hours = padNumber(difference.hours, difference.value);
                this.countdown.minutes = padNumber(difference.minutes, difference.value);
                this.countdown.seconds = padNumber(difference.seconds, difference.value);

                requestAnimationFrame(updateDifference);
            };

            updateDifference();
        }
    },

    dismiss() {
        this.visible = false;
        document.body.classList.remove(this.announcementId + '-announcement-is-visible');
        Cookies.set(this.announcementId, 1, { expires: 1 });
        window.dispatchEvent(new CustomEvent('gifted.announcementClosed'));
    },

    async submitForm(event) {
        if (this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;

        const form = event.target;

        try {
            const response = await fetch(form.getAttribute('action'), {
                method: form.getAttribute('method'),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(new FormData(form)),
            });

            if (response.ok) {
                this.formSubmitted = true;
            }
        } catch (error) {
            console.error(error);
        }
    },
});
